import { render, staticRenderFns } from "./FormInputGroupSize.vue?vue&type=template&id=763cd46d&"
import script from "./FormInputGroupSize.vue?vue&type=script&lang=js&"
export * from "./FormInputGroupSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports